exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-controller-toggle-on{--fa-primary-color: white}.edit-controller-toggle-off{--fa-secondary-color: white}.edit-controller-small-input{padding-top:0px;padding-bottom:0px;height:20px;font-size:11px}.edit-controller-small-btn{height:20px;font-size:11px}.edit-controller-small-btn-caret{margin-top:0px}.edit-controller-table{overflow-y:auto;max-height:54rem;min-height:54rem;display:block}\n", ""]);

// exports
